import { Check, X } from 'lucide-react'

export function SecurityComparison() {
  const comparisonData = [
    { 
      feature: 'Client-Side Encryption', 
      safemonk: true, 
      others: false,
      description: 'Encryption in your browser'
    },
    { 
      feature: 'Zero-Knowledge Architecture', 
      safemonk: true, 
      others: false,
      description: 'Provider cannot decrypt'
    },
    { 
      feature: 'No Account Required', 
      safemonk: true, 
      others: false,
      description: 'Complete anonymity'
    },
    { 
      feature: 'Burn-After-Read', 
      safemonk: true, 
      others: 'partial',
      description: 'True deletion after viewing'
    },
    { 
      feature: 'Open Source Crypto', 
      safemonk: true, 
      others: 'partial',
      description: 'Auditable encryption'
    },
    { 
      feature: 'Large File Support', 
      safemonk: true, 
      others: true,
      description: 'Up to 500MB files'
    }
  ]

  return (
    <div className="mt-12 sm:mt-16 mb-12 sm:mb-16">
      <h2 className="text-2xl sm:text-3xl font-mono font-semibold text-center text-foreground mb-8 sm:mb-12">
        Why SafeMonk is More Secure
      </h2>
      
      {/* Mobile View - Cards */}
      <div className="block sm:hidden space-y-4">
        {comparisonData.map((item, i) => (
          <div key={i} className="bg-card border border-border rounded-card p-4">
            <h3 className="font-semibold text-foreground mb-2">{item.feature}</h3>
            <p className="text-sm text-muted-foreground mb-3">{item.description}</p>
            <div className="flex gap-4">
              <div className="flex items-center gap-2">
                <span className="text-xs font-medium text-muted-foreground">SafeMonk:</span>
                {item.safemonk ? (
                  <Check className="w-4 h-4 text-primary" />
                ) : (
                  <X className="w-4 h-4 text-destructive" />
                )}
              </div>
              <div className="flex items-center gap-2">
                <span className="text-xs font-medium text-muted-foreground">Others:</span>
                {item.others === true ? (
                  <Check className="w-4 h-4 text-primary" />
                ) : item.others === 'partial' ? (
                  <span className="text-xs text-warning-yellow">Partial</span>
                ) : (
                  <X className="w-4 h-4 text-destructive" />
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Desktop View - Table */}
      <div className="hidden sm:block overflow-x-auto">
        <table className="w-full bg-card border border-border rounded-card overflow-hidden">
          <thead>
            <tr className="border-b border-border bg-muted/50">
              <th className="text-left p-4 sm:p-6 font-semibold text-foreground">Feature</th>
              <th className="text-center p-4 sm:p-6 font-semibold text-primary">SafeMonk</th>
              <th className="text-center p-4 sm:p-6 font-semibold text-muted-foreground">Other Services</th>
            </tr>
          </thead>
          <tbody>
            {comparisonData.map((item, i) => (
              <tr key={i} className="border-b border-border last:border-b-0">
                <td className="p-4 sm:p-6">
                  <div>
                    <div className="font-medium text-foreground">{item.feature}</div>
                    <div className="text-sm text-muted-foreground mt-1">{item.description}</div>
                  </div>
                </td>
                <td className="text-center p-4 sm:p-6">
                  {item.safemonk ? (
                    <Check className="w-5 h-5 text-primary mx-auto" />
                  ) : (
                    <X className="w-5 h-5 text-destructive mx-auto" />
                  )}
                </td>
                <td className="text-center p-4 sm:p-6">
                  {item.others === true ? (
                    <Check className="w-5 h-5 text-primary mx-auto" />
                  ) : item.others === 'partial' ? (
                    <span className="text-sm text-warning-yellow">Partial</span>
                  ) : (
                    <X className="w-5 h-5 text-destructive mx-auto" />
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}